/**
 * Elastic `divisionIds` for a division-scoped sidebar search, narrowed like
 * the Timeline: `[]` (all org divisions) only when the role is org-wide and
 * the selector is not empty; otherwise the selector intersected with the
 * divisions the entity's matrix allows. `null` means there is nothing the
 * user may search.
 */
export const resolveSearchDivisionIds = (
  elasticDivIds: string[],
  allowedDivsIds: string[],
  allowedSelectedDivs: string[],
): string[] | null => {
  if (elasticDivIds.length === 0) {
    return allowedSelectedDivs.length > 0 ? [] : null;
  }
  const scoped = elasticDivIds.filter(divId => allowedDivsIds.includes(divId));
  return scoped.length > 0 ? scoped : null;
};
